import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Nav from "./components/Nav";
import AddNew from "./pages/AddNew";
import EditTask from "./pages/EditTask";
import Home from "./pages/Home";
import "./styles/main.css";

function App() {
  return (
    <BrowserRouter>
      <Nav />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/addNew" element={<AddNew />} />
        <Route path="/editTask/:taskId" element={<EditTask />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
